// DebugConsole.js
var DebugConsole = pc.createScript('debugConsole');

DebugConsole.attributes.add('enableConsole', {type: 'boolean'});
DebugConsole.attributes.add("font", {type: "asset", assetType: "font"});

DebugConsole.prototype.initialize = function() {
    if(this.enableConsole) {
        this.createTextEntity();
        
        this.app.on('setDebugText', this.onSetDebugText, this);
        
        this.app.fire('setDebugText', {text:'debug text'});
    }
};

DebugConsole.prototype.createHTMLConsole = function (textElement) {
    var div = document.createElement('div');
    div.style.position = 'absolute';
    div.style.top = 0;
    div.style.width = '100%';
    div.style.height = '100px';
    div.style.zIndex = 100;
    div.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
    div.style.color = '#fff';
    div.setAttribute('id','debug-window');
    document.body.appendChild(div);

    //debug with this
    document.getElementById('debug-window').innerHTML += 'debug message 1 / ';
    document.getElementById('debug-window').innerHTML += 'debug message 2 / ';
    document.getElementById('debug-window').innerHTML += 'debug message 3 / ';
};

DebugConsole.prototype.createTextEntity = function () {
    var textEntity = new pc.Entity();
    textEntity.name = "debug-text";
    
    textEntity.addComponent('element', {
        type: pc.ELEMENTTYPE_TEXT ,
        anchor: new pc.Vec4(0.5,1,0.5,1),
        pivot: new pc.Vec2(0.5,1),
        preset: "Center",
        width: 256 ,
        height: 256,
        fontAsset: this.font,
        fontSize: 4, 
        rect: [0,0,1,0.25],
        color: new pc.Color(1,0,0)
    });
    
    //console.log(textEntity.element.color);
    
    textEntity.element.text = 'test lorem ipsum';
    
    this.entity.addChild(textEntity);
    
    textEntity.setPosition(5, 6, 0);
    textEntity.setEulerAngles(0, 90, 0);
    textEntity.setLocalScale(1, 1, 1);
    
};

DebugConsole.prototype.onSetDebugText = function (event) {
    this.app.root.findByName('debug-text').element.text = event.text;
};


